module.exports = __webpack_public_path__ + "static/media/oneplus.96a8e62b.png";